import { KeyValuePairNumeric, VwpOrderCategory } from "@components/WeddingSupplierPackages/types";
import axios from "axios";

export const storeVwpOrder = async (order: VwpOrderCategory, redeem: boolean, date: string): Promise<KeyValuePairNumeric> => {
    const data = JSON.stringify(order);
    try {
        const response = await axios.post<KeyValuePairNumeric>(
            `/packages/store/order/?redeem=${redeem}&date=${date}`,
            data,
            {
                headers: { 'Content-Type': 'application/json' }
            }
        );
        
        const responseData: KeyValuePairNumeric = response.data;
        return responseData;
    } catch (error) {
        if (axios.isAxiosError(error)) {
            console.error('Axios error:', error.message);
        } else {
            console.error('Unexpected error:', error);
        }
        throw error;
    }
};